import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import type { RegisterUserPayload, AuthResponse } from "./types";
import { apiPost, sanitizeEmail, sanitizeName } from "../shared";

export default async function registerUser(
  name: string,
  email: string,
  password: string,
  passwordRepeat: string
): Promise<AuthResponse> {
  const payload: RegisterUserPayload = {
    name: sanitizeName(name),
    email: sanitizeEmail(email),
    password,
    passwordRepeat,
  };

  validate.name(payload.name);
  validate.email(payload.email);
  validate.password(payload.password);
  validate.passwordsMatch(payload.password, payload.passwordRepeat);

  const result = await apiPost<AuthResponse>(USER_ENDPOINTS.REGISTER, payload);
  window.dispatchEvent(new Event("authChange"));

  return { success: true, user: result.user };
}
